import { Alert, Button, Paper, Stack, Text, Title } from "@mantine/core";
import { IconPlug, IconRocket } from "@tabler/icons-react";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FailedAlert, MCLoader } from "../../../../components";
import { useEnableMcBimMutation, useGetProjectQuery } from "../../../projectRTK";
import { getProjectIdFromUrl } from "../../../utils";
import { ConnectAutodeskProjectModal } from "../bim360Settings/ConnectAutodeskProjectModal";
import { useGetMcBimProjectQuery } from "./McBimRTK";

const McBimActivate: React.FC = () => {
  const location = useLocation();

  const history = useHistory();
  const projectId = getProjectIdFromUrl(location.pathname);

  const [connectBim360ModalOpen, setConnectBim360ModalOpen] = React.useState(false);

  const { data: project, isLoading: projectLoading, refetch: refetchProject } = useGetProjectQuery(projectId);

  const mcbimIsActivated = project?.mcbim?.activated;

  const bim360Activated = project?.bim360?.projectId != null;

  const {
    data: mcbimProject,
    isLoading: mcbimProjectLoading,
    error: mcbimProjectError,
  } = useGetMcBimProjectQuery(projectId, {
    skip: project?.mcbim?.activated !== true,
  });

  React.useEffect(() => {
    const url = history.location.pathname;
    const urlToRedirectTo = `/project/${projectId}/bimai/mcbimsettings/activefiles`;
    if (mcbimProject != null && url !== urlToRedirectTo) {
      history.push(`/project/${projectId}/bimai/mcbimsettings/activefiles`);
    }
  }, [mcbimProject]);

  const [enableMcBim, { isLoading: enableMcBimLoading, error: createMcBimFailed }] = useEnableMcBimMutation();

  const isLoading = enableMcBimLoading || projectLoading || mcbimProjectLoading;

  const isError = createMcBimFailed != null || mcbimProjectError != null;
  return (
    <>
      <ConnectAutodeskProjectModal
        opened={connectBim360ModalOpen}
        onClose={() => setConnectBim360ModalOpen(false)}
        onConnected={() => {
          refetchProject();
          setConnectBim360ModalOpen(false);
        }}
        projectId={projectId}
      />
      {mcbimProjectError != null && <Alert color="red">Failed to fetch mcbim project</Alert>}
      {mcbimIsActivated !== true && isLoading !== true && isError !== true && (
        <Paper withBorder radius="md" p="lg" maw={560}>
          <Stack gap="md">
            <div>
              <Title order={3}>MCBIM</Title>
              <Text c="dimmed" size="sm" mt={4}>
                MCBIM lagrer og håndterer BIM-data fra IFC-filer, slik at dataene kan brukes i MCApps og eksterne
                verktøy som Excel, PowerBI og Python.
              </Text>
            </div>

            {bim360Activated !== true && (
              <Alert color="blue" title="Koble til ACC">
                <Stack gap="sm">
                  <Text size="sm">For å bruke MCBIM kreves det at en integrasjon er satt opp mot ACC.</Text>
                  <Button
                    color="blue"
                    fullWidth
                    leftSection={<IconPlug size={16} />}
                    onClick={() => setConnectBim360ModalOpen(true)}
                  >
                    Koble ditt MCApps-prosjekt til ACC.
                  </Button>
                </Stack>
              </Alert>
            )}
            {bim360Activated === true && (
              <Button
                color="green"
                fullWidth
                leftSection={<IconRocket size={16} />}
                onClick={() => enableMcBim(projectId)}
              >
                Aktiver MCBIM
              </Button>
            )}
          </Stack>
        </Paper>
      )}
      {createMcBimFailed != null && <FailedAlert />}
      {mcbimProjectError != null && <span>Failed to fetch mcbim project</span>}
      {isLoading === true && <MCLoader loading={true} />}
    </>
  );
};

export default McBimActivate;
